import Vue from "vue";
import Component from "vue-class-component";

const AlertMessageProps = Vue.extend({
  props: {
    icon: {
      type: String,
      default: "error",
    },
    message: {
      type: String,
      default: "",
      required: true,
    },
    color: {
      type: String,
      default: "#FF9100",
    }
  },
});

@Component<AlertMessage>({
  name: "AlertMessage",
})

export default class AlertMessage extends AlertMessageProps {

  constructor() {
    super();
  }
}
